import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'core/core.module';
import { GroupsComponentsModule } from 'app/groups/groups-components.module';
import { WidgetContainerComponent } from './widget-container/widget-container.component';
import { WidgetAnchorDirective } from './directives/widget-anchor/widget-anchor.directive';
import {
  GroupsListWidgetComponent,
  BestCommentsWidgetComponent,
  HistoricWidgetComponent,
  LicensesTotalsWidgetComponent,
  ActiveGroupsWidgetComponent,
  CreditsListWidgetComponent
} from './widgets';
import { DashboardService } from './services/dashboard.service';
import { DashboardDataService } from './services/dashboard-data.service';
import { MyPlanComponent } from './components/my-plan/my-plan.component';
import { SubscriptionActivationComponent } from '@widgets/components/subscription-activation/subscription-activation.component';
import { TrainingHourComponent } from './components/training-hour/training-hour.component';
import { MetricComponent } from './components/metric/metric.component';
import { NpsComponent } from './components/nps/nps.component';
import { AutoevaluationComponent } from './components/autoevaluation/autoevaluation.component';
import { AutoevaluationCoursesComponent } from './components/autoevaluationCourses/autoevaluationCourses.component';
import { ApplicabilityComponent } from './components/applicability/applicability.component';
import { StudentCourseComponent } from './components/student-course/student-course.component';
import { StudentCommentComponent } from './components/student-comment/student-comment.component';
import { ScheduledClassComponent } from './components/scheduled-class/scheduled-class.component';
import { AutoevaluationsService } from '@widgets/services/autoevaluations.service';
@NgModule({
  imports: [CommonModule, CoreModule, GroupsComponentsModule],
  declarations: [
    AutoevaluationComponent,
    AutoevaluationCoursesComponent,
    ApplicabilityComponent,
    WidgetContainerComponent,
    WidgetAnchorDirective,
    GroupsListWidgetComponent,
    BestCommentsWidgetComponent,
    HistoricWidgetComponent,
    LicensesTotalsWidgetComponent,
    ActiveGroupsWidgetComponent,
    CreditsListWidgetComponent,
    MyPlanComponent,
    TrainingHourComponent,
    MetricComponent,
    NpsComponent,
    StudentCourseComponent,
    StudentCommentComponent,
    ScheduledClassComponent,
    SubscriptionActivationComponent
  ],
  exports: [
    AutoevaluationCoursesComponent,
    WidgetContainerComponent,
    WidgetAnchorDirective,
    GroupsListWidgetComponent,
    BestCommentsWidgetComponent,
    HistoricWidgetComponent,
    LicensesTotalsWidgetComponent,
    ActiveGroupsWidgetComponent,
    CreditsListWidgetComponent,
    MyPlanComponent,
    SubscriptionActivationComponent
  ],
  providers: [DashboardService, DashboardDataService, AutoevaluationsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WidgetModule {}
